// extracted by mini-css-extract-plugin
module.exports = {"outer":"CardAgenda_outer__2QRUI","cardArtistePrecis":"CardAgenda_cardArtistePrecis__VRmYv","imgGrey":"CardAgenda_imgGrey__3uXP0"};